import * as React from "react";
import Card from "../core/Card";
import * as H from "history";
import CenterDiv from "../core/CenterDiv";
import CoreDropzone from "../core/CoreDropzone";
import ProgressBar from "../core/ProgressBar";
import Loader from "../core/Loader";
import { uniqueId } from "lodash";
import jfetch from "../../utils/jfetch";
import styled from "styled-components";
import * as moment from "moment";

interface IProps {
  org: IOrganization;
  routerHistory: H.History;
  userIsAdmin?: boolean;
}

interface IState {
  edit: boolean;
  loading: boolean;
  uploadingFile: any;
  uploadedFile: any;
}

const PDFContainer = styled.object`
  width: 100%;
  min-width: 600px;
  height: 800px;
`;

class StrategyPlan extends React.Component<IProps, IState> {
  _isMounted = false;

  state: IState = {
    edit: false,
    loading: true,
    uploadingFile: null,
    uploadedFile: null,
  };

  componentDidMount(): void {
    this._isMounted = true;
    this.getStrategyFile();
  }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

  getStrategyFile = async () => {
    this.setState({ loading: true });
    let result;
    try {
      result = await jfetch.get(`${this.props.org.links.url}/strategy_plan`);
    } catch (e) {
      if (e.statusCode && e.statusCode === 422) {
        // no file found
      } else {
        throw e;
      }
    }
    if (result && result.data && this._isMounted) {
      const resultData = result.data.attributes;
      this.setState({
        uploadedFile: {
          url: resultData.strategyPlanFilesUrl,
          name: resultData.strategyPlanFilesName,
        },
      });
    }
    this.setState({ loading: false });
  };

  onFileDrop = async acceptedFiles => {
    const uploadId = uniqueId("upload_");
    if (Array.isArray(acceptedFiles) && acceptedFiles.length > 0) {
      this.setState({
        loading: true,
        uploadingFile: { name: acceptedFiles[0]["name"], uploadId },
      });

      const data = new FormData();
      acceptedFiles.forEach(file => data.append("strategy_plan_files", file));

      const result = await jfetch.post(
        `${this.props.org.links.url}/strategy_plan`,
        data
      );
      if (result) {
        this.setState({
          uploadingFile: null,
          loading: false,
        });
        if (result.data.attributes) {
          const resultData = result.data.attributes;
          this.setState({
            uploadedFile: {
              url: resultData.strategyPlanFilesUrl,
              name: resultData.strategyPlanFilesName,
              updated: resultData.strategyPlanFilesUpdated,
            },
          });
        }
      }
    }
  };

  render() {
    const { org, routerHistory, userIsAdmin } = this.props;
    const { edit, loading, uploadingFile, uploadedFile } = this.state;
    return (
      <Card title={`Strategy plan for ${org.name}`}>
        {loading ? (
          <Loader />
        ) : userIsAdmin ? (
          <div className="panel panel-info">
            <div className="panel-heading">Current Strategy Plan</div>
            <div className="panel-body">
              {uploadedFile ? (
                <table className="table">
                  <thead>
                    <tr>
                      <th> File Name </th>
                      <th> Date Uploaded </th>
                      <th> Edit </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <a target={"_blank"} href={uploadedFile.url} rel="noopener noreferrer" >
                          {uploadedFile.name}
                        </a>
                      </td>
                      <td>
                        {moment(uploadedFile.updated).format("MM/DD/YYYY")}
                      </td>
                      <td>
                        <a
                          onClick={() => {
                            this.setState({ edit: true });
                          }}
                        >
                          <i className="fa fa-upload" />
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <p>Nothing yet.</p>
              )}

              {(edit || !uploadedFile) && (
                <>
                  <hr />
                  Upload Strategy Plan:
                  <CenterDiv>
                    <CoreDropzone onDrop={this.onFileDrop}>
                      Drop Files Here or Click to Upload
                    </CoreDropzone>
                  </CenterDiv>
                </>
              )}
              <CenterDiv>
                {uploadingFile && (
                  <p>
                    <strong>Uploading Files...</strong>
                  </p>
                )}
                {uploadingFile && (
                  <ProgressBar
                    key={`${uploadingFile.uploadId}_${uploadingFile.name}`}
                    active={true}
                    progress={100}
                    striped={true}
                  >
                    {uploadingFile.name}
                  </ProgressBar>
                )}
              </CenterDiv>
            </div>
          </div>
        ) : uploadedFile ? (
          <PDFContainer data={uploadedFile.url} type="application/pdf">
            <embed src={uploadedFile.url} type="application/pdf" />
          </PDFContainer>
        ) : (
          <div> No strategy plan at the moment </div>
        )}
      </Card>
    );
  }
}

export default StrategyPlan;



// WEBPACK FOOTER //
// ./app/javascript/components/org/StrategyPlan.tsx